export const MODULE_CATALOG = {
  personas: {
    title: "PERSONAS Y ASOCIADOS",
    eyebrow: "PADRÓN Y LEGAJOS",
    description: "ALTA Y CONSULTA DE PERSONAS FÍSICAS, PERSONAS JURÍDICAS, ASOCIADOS, AUTORIZADOS Y BENEFICIARIOS FINALES.",
    permission: "personas.view",
    status: "OPERATIVO",
    sections: [
      "DATOS COMUNES",
      "PERSONAS FÍSICAS Y JURÍDICAS",
      "DATOS FINANCIEROS Y ASOCIACIÓN",
      "PERSONAS AUTORIZADAS",
      "BENEFICIARIOS FINALES DE PERSONAS JURÍDICAS",
    ],
    rules: [
      "UNA PERSONA PUEDE EXISTIR SIN SER ASOCIADA.",
      "EL NÚMERO DE SOCIO ES EL ID AUTOINCREMENTAL DE LA ASOCIACIÓN.",
      "AUTORIZADOS Y BENEFICIARIOS DEBEN REGISTRARSE PREVIAMENTE COMO PERSONAS.",
    ],
  },
  ayudas: {
    title: "Ayudas económicas",
    eyebrow: "Créditos y liquidaciones",
    description: "Liquidación, consulta, planes, garantías, acreditación en caja de ahorro común, mutuos y renovaciones.",
    permission: "ayudas.view",
    status: "Operativo",
    sections: [
      "Liquidación y consulta por socio o número",
      "Productos A, B, E, I y J configurables",
      "Sistemas de amortización y tasas versionadas",
      "Garantías, garantes y destino",
      "Liquidación, desembolso y mutuo",
      "Renovaciones e historial de estados",
    ],
    rules: [
      "Las letras A, B, E, I y J conservan la operatoria documentada de la Mutual.",
      "Cada condición aprobada conservará su versión histórica.",
      "No habrá desembolsos duplicados ni edición silenciosa del plan.",
    ],
  },
  cobranzas: {
    title: "Cobranzas y mora",
    eyebrow: "Imputación y recuperación",
    description: "Registro de pagos, imputación por componentes, intereses de mora, anulaciones y refinanciaciones.",
    permission: "cobranzas.view",
    status: "Estructura inicial",
    sections: [
      "Cuotas y composición financiera",
      "Cobros e imputaciones",
      "Intereses compensatorios y punitorios",
      "Anulaciones y reversos",
      "Mora, convenios y refinanciaciones",
    ],
    rules: [
      "Cobros y anulaciones serán idempotentes y transaccionales.",
      "Una reversión restaurará exactamente deuda y fondos.",
      "Capital, interés, seguro y gastos no se mezclarán en un importe único.",
    ],
  },
  cuentas: {
    title: "Cuentas de socios",
    eyebrow: "Caja de ahorro mutual",
    description: "Subledger de cuentas comunes y especiales, con movimientos, transferencias y devengamientos.",
    permission: "cuentas.view",
    status: "Estructura inicial",
    sections: [
      "Caja de ahorro común",
      "Caja de ahorro especial",
      "Depósitos, retiros y transferencias",
      "Acreditación de liquidaciones",
      "Devengamientos y saldos conciliables",
    ],
    rules: [
      "El saldo visible se reconstruirá desde movimientos inmutables.",
      "La liquidación de una ayuda acreditará primero la cuenta definida.",
      "Los pases entre cuentas serán dos movimientos vinculados.",
    ],
  },
  ahorros: {
    title: "Ahorros a término",
    eyebrow: "Captaciones en pesos y dólares",
    description: "Gestión de imposiciones a plazo, tasas por rango, vencimientos, intereses y renovaciones.",
    permission: "ahorros.view",
    status: "Estructura inicial",
    sections: [
      "Ahorros a término en pesos",
      "Ahorros a término en dólares",
      "Tasas por monto y plazo",
      "Vencimientos y liquidación de intereses",
      "Renovaciones totales o parciales",
    ],
    rules: [
      "La tasa aplicada quedará congelada por operación.",
      "Toda renovación creará una operación vinculada, sin borrar la anterior.",
      "Moneda, capital, interés y fondos agregados o retirados quedarán separados.",
    ],
  },
  valores: {
    title: "Valores y cheques",
    eyebrow: "Compra y seguimiento",
    description: "Administración de cheques físicos y electrónicos vinculados a ayudas, depósitos y acreditaciones.",
    permission: "valores.view",
    status: "Estructura inicial",
    sections: [
      "Carga de cheques y eCheq",
      "Endosos y documentación",
      "Cartera y depósitos bancarios",
      "Acreditaciones y liberaciones",
      "Rechazos, reclamos y recuperos",
    ],
    rules: [
      "Cada valor tendrá identidad y ciclo de vida propio.",
      "No se permitirá importar o registrar dos veces el mismo instrumento.",
      "Un rechazo no eliminará el valor ni su historia.",
    ],
  },
  caja: {
    title: "Caja y tesorería",
    eyebrow: "Operación diaria",
    description: "Aperturas, cierres, arqueos, ingresos, egresos y control de medios de pago.",
    permission: "caja.view",
    status: "Estructura inicial",
    sections: [
      "Cajas y asignación por usuario",
      "Apertura y cierre",
      "Ingresos, egresos y comprobantes",
      "Medios de pago y valores",
      "Arqueos, diferencias y reversos",
    ],
    rules: [
      "No se registrarán movimientos sobre una caja cerrada.",
      "El cierre inmovilizará los movimientos incluidos.",
      "Toda diferencia tendrá motivo y responsable.",
    ],
  },
  bancos: {
    title: "Bancos y conciliaciones",
    eyebrow: "Fondos externos",
    description: "Cuentas bancarias, transferencias, extractos, importaciones y conciliación con el sistema interno.",
    permission: "bancos.view",
    status: "Estructura inicial",
    sections: [
      "Bancos y cuentas bancarias",
      "Transferencias y depósitos",
      "Importación de extractos",
      "Conciliación automática y asistida",
      "Integraciones con proveedores",
    ],
    rules: [
      "Los extractos originales serán inmutables.",
      "Las líneas repetidas se bloquearán por identificador o huella.",
      "Las integraciones se implementarán detrás de adaptadores desacoplados.",
    ],
  },
  contabilidad: {
    title: "Contabilidad",
    eyebrow: "Partida doble y cierres",
    description: "Plan de cuentas, asientos automáticos, diarios, mayores, períodos y cierres contables.",
    permission: "contabilidad.view",
    status: "Estructura inicial",
    sections: [
      "Plan de cuentas versionado",
      "Asientos manuales y automáticos",
      "Diario, mayor y balances",
      "Períodos, cierres y reaperturas",
      "Reglas de contabilización por evento",
    ],
    rules: [
      "Todo asiento deberá balancear debe contra haber.",
      "Los módulos operativos emitirán eventos contables definidos.",
      "Un período cerrado no cambiará sin reapertura autorizada y auditada.",
    ],
  },
  documentos: {
    title: "Documentos y comprobantes",
    eyebrow: "Trazabilidad documental",
    description: "Plantillas, mutuos, recibos, legajos y archivos privados con versionado y control de acceso.",
    permission: "documentos.view",
    status: "Estructura inicial",
    sections: [
      "Plantillas legales versionadas",
      "Mutuos y contratos generados",
      "Recibos y comprobantes",
      "Documentos de personas y operaciones",
      "Descargas autorizadas y retención",
    ],
    rules: [
      "Un documento histórico conservará la versión de plantilla utilizada.",
      "Los archivos no tendrán URL pública permanente.",
      "Subidas, descargas y reemplazos quedarán auditados.",
    ],
  },
  reportes: {
    title: "Reportes y exportaciones",
    eyebrow: "Información operativa",
    description: "Consultas, informes financieros y exportaciones controladas para operación, dirección y cumplimiento.",
    permission: "reportes.view",
    status: "Estructura inicial",
    sections: [
      "Reportes operativos",
      "Reportes financieros",
      "Reportes regulatorios",
      "Exportaciones PDF, Excel y CSV",
      "Historial de archivos generados",
    ],
    rules: [
      "Los filtros y límites se aplicarán en servidor.",
      "Las exportaciones masivas requerirán permiso específico.",
      "Cada archivo generado tendrá usuario, criterios y vencimiento.",
    ],
  },
  auditoria: {
    title: "Auditoría",
    eyebrow: "Evidencia y seguridad",
    description: "Registro inmutable de accesos, operaciones financieras, usuarios y configuraciones con detalle antes/después.",
    permission: "auditoria.view",
    status: "Operativo",
    sections: [
      "Inicios de sesión y bloqueos",
      "Operaciones financieras",
      "Aprobaciones y anulaciones",
      "Cambios de permisos y configuración",
      "Exportaciones y acceso a documentos",
    ],
    rules: [
      "Los eventos no se editarán ni eliminarán desde la aplicación.",
      "Nunca se registrarán contraseñas, tokens o payloads sensibles completos.",
      "Cada evento tendrá actor, acción, entidad, fecha y correlation ID.",
    ],
  },
  configuracion: {
    title: "Configuración",
    eyebrow: "Parámetros del sistema",
    description: "Administración institucional, usuarios, permisos, productos, monedas, tasas, sucursales y seguridad.",
    permission: "configuracion.view",
    status: "Estructura inicial",
    sections: [
      "Usuarios, roles y permisos",
      "Sucursales, cajas y responsables",
      "Productos financieros y parámetros",
      "Monedas, cotizaciones y tasas",
      "Datos institucionales y numeraciones",
      "Seguridad, sesiones y alertas",
    ],
    rules: [
      "La configuración corresponde a una única institución.",
      "Los parámetros financieros tendrán vigencia y versión.",
      "Los cambios críticos requerirán permisos y auditoría reforzada.",
    ],
  },
};
